// eslint-disable-next-line @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any
export const PrivateEmbedSettings = (props: any) => {
  return null;
};
